<template>
  	<router-link
		class="unitExperience-link"
		:to="{
		name: 'unitExperience',
		params: {
			unitId: unitExperience.unit_id,
			experienceId: unitExperience.experience_id,
		},
		}">
		<v-card class="mx-auto unitExperienceCard" max-width="280" :loading="loading">
			<template v-slot:loader="{ isActive }">
				<v-progress-linear
					:active="isActive"
					color="deep-purple"
					height="4"
					indeterminate
				></v-progress-linear>
			</template>
			<v-img
				v-if="unitExperience.img_path"
				:src="`${unitExperience.img_path}`"
				height="200px"
				cover
				class="fitProductImage"
			></v-img>
			<v-img
				v-else
				src="@/assets/static/images/noImage.png"
				height="200px"
				cover
				class="fitProductImage"
			></v-img>
			<div style="text-align: left">
				<div class="card-title bold">{{unitExperience.experience_name}}</div>
			</div>
			<!-- <div class="trashIcon" @click="deleteUnitExperience">
					<font-awesome-icon icon="trash" />
			</div> -->
		</v-card>  
 	</router-link>
</template>

<script>
export default {
  data() {
    return {
      unitId: this.unitExperience.unit_id,
      experienceId: this.unitExperience.experience_id,
      baseUrl: process.env.VUE_APP_API_URL,
	  loading: false,
    }
  },
  methods: {
    // deleteUnitExperience(event) {
    //   event.preventDefault()
    //   if (confirm('Are you sure?')) {
    //     this.$store
    //       .dispatch('experience/removeUnitExperience', {
    //         unitId: this.unitId,
    //         experienceId: this.experienceId,
    //       })
    //       .then(() => {
    //         this.$store.dispatch('experience/fetchUnitExperiences', this.unitId)
    //       })
    //       .catch((e) => console.log(e))
    //   }
    // },
	reserve () {
        this.loading = true
        setTimeout(() => (this.loading = false), 2000)
    },
  },
  props: {
    unitExperience: {
      type: Object,
      default: () => {
        return {}
      },
    },
    unit: {
      type: Object,
      default: () => {
        return {}
      },
    },
    product: {
      type: Object,
      default: () => {
        return {}
      },
    },
  },
}
</script>

<style lang="scss" scoped>

.unitExperience-link {
	text-decoration: none;
}

.fitProductImage {
	width: 100% !important;
  	object-fit: cover !important;
}

.unitExperienceCard {
	height: 280px;
	margin: 20px 10px !important;
}

.card-title {
	width: 220px;
	overflow: hidden;
	text-overflow: ellipsis;
	-webkit-line-clamp: 2;
	display: -webkit-box;
	-webkit-box-orient: vertical;
	margin-top:15px;
	margin: 10px;
	text-align: left;
	font-size: 1.1rem;
	font-weight: 800;
}
.bold {
	font-weight: 700 !important;

}
.card {
  box-shadow: rgba(0, 0, 0, 0.117647) 0px 1px 6px, rgba(0, 0, 0, 0.117647) 0px 1px 4px;
  transition: .15s all ease-in-out;
  &:hover {
    transform: scale(1.1);
  }
}

.card-body {
	color: #454655;
	padding: 0.5rem;
}
.card-body:active {
	color: var(--primaryDark);
	text-decoration:none;
}
.card-name {
	color: #454655;
    width: 100%;
}
.product-card:active {
  background: #707181;
  /* margin: 16px;
  padding: 20px; */
  border-radius: 5px;
}

.trashIcon {
	background: var(--primaryDark);
	color: var(--bright);
	padding: 10px;
	border: none;
	border-radius: 5px;
	width: 35px;
	height: 40px;
    position: absolute;
    right: 10px;
    margin: 0;
    bottom: 10px;
}

.icon {
  font-size: 1.3em;
  padding: 1px;
}

.iconWrapper {
	display: flex;
	flex-wrap: nowrap;
	align-items: right;
	justify-content: right;
	margin: -10px 5px 5px 0px;
}

.iconWrapper div {
    padding: 7px;
	margin-left: 2px;
    border-radius: 50%;
    color: var(--bright);
	align-self: flex-end;
}


.baseBg {
    background-color: var(--bg);
}
.starIcon {
    color: var(--primaryDark);
	margin: 0 3px;
}
.card {
    box-shadow: rgba(0, 0, 0, 0.117647) 0px 1px 6px, rgba(0, 0, 0, 0.117647) 0px 1px 4px;
    transition: .15s all ease-in-out;
    &:hover {
      transform: scale(1.1);
    }
  }

  @media screen and (min-width: 500px){
	.unitExperienceCard:hover {
	background: rgba(128, 128, 128, 0.2) !important;
	box-shadow: rgba(0, 0, 0, 0.117647) 0px 1px 6px, rgba(0, 0, 0, 0.117647) 0px 1px 4px;
	margin: 10px !important;
	transform: scale(1.03);
}
}

  @media only screen and (max-device-width: 769px) {
	.unitExperienceCard {
		height: auto !important;
	}
}

  @media screen and (max-width: 500px){
	.unitExperienceCard {
    margin: auto !important;
	margin-bottom: 20px !important;
	min-height: 260px;
	padding-left: 0 !important;
  }
  .card-title {
		width: 225px !important;
		margin-top: 10px;
		// line-height: 30px;
  }
}

@media only screen and (min-device-width: 300px) and (max-device-width: 359px){
	.card-title {
	width: 240px;
	font-size: 1.2rem;
	text-align: left;
}
}

@media only screen and (min-device-width: 360px) and (max-device-width: 379px){
	.card-title {
	width: 270px;
}
}

</style>
